import Vue from 'vue'

export default {
  unsetAllByKey (array, params) {
    for (let i = 0; i < array.length; i++) {
      if (array[i][params.key]) {
        array[i][params.key] = null
      }
    }
  },
  getById (array, object) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].id === object.id) {
        return array[i]
      }
    }
  },
  updateById (array, object) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].id === object.id) {
        if (array[i].type && object.type) {
          if (array[i].type === object.type) {
            array[i] = object
          }
        } else {
          array[i] = object
        }
      }
    }
    return array
  },
  existsById (array, object) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].id === object.id) {
        if (array[i].type && object.type) {
          return array[i].type === object.type
        }
        return true
      }
    }
    return false
  },
  removeById (array, object) {
    if (!Array.isArray(array) || !object) return
    // Iterate backwards so splice does not skip the next item
    for (let i = array.length - 1; i >= 0; i--) {
      const row = array[i]
      if (!row || String(row.id) !== String(object.id)) continue
      if (row.type != null && object.type != null && String(row.type) !== String(object.type)) {
        continue
      }
      array.splice(i, 1)
    }
  },
  removeAllByValue (array, value) {
    for (let i = 0; i < array.length; i++) {
      if (array[i] === value) {
        array.splice(i, 1)
      }
    }
  }
}
